import { Base } from "../base";

export class VehicleExceptionUpdate extends Base {
    VehicleExceptionID?: string;
    VehicleID?: string;
    FullName?: string;
    Phone?: string;
    VehiclePlate?: string;
    FromDate?: Date;
    ToDate?: Date;
    Description?: string;

    constructor(
        vehicleExceptionId: string,
        vehicleId: string,
        fullName: string,
        phone: string,
        vehiclePlate: string,
        fromDate: Date,
        toDate: Date,
        description: string
    ) {
        super();
        this.VehicleExceptionID = vehicleExceptionId;
        this.VehicleID = vehicleId;
        this.FullName = fullName;
        this.Phone = phone;
        this.VehiclePlate = vehiclePlate;
        this.FromDate = fromDate;
        this.ToDate = toDate;
        this.Description = description;
    }
}